import React from 'react';
import { ILowerTopBarLink, useLowerTopBarState } from './LowerTopBar.state';
import LowerTopBarView from './LowerTopBar.view';

export interface ILowerTopBarStyles {
    textColor?: string;
    backgroundColor?: string;
    barLogo?: string;
}

const LowerTopBar: React.FC<{ title?: string; links?: ILowerTopBarLink[]; children?: any }> = (props) => {
    const state = useLowerTopBarState();

    return <LowerTopBarView {...{ ...state }}>{props.children}</LowerTopBarView>;
};

export default LowerTopBar;
